import * as apiroutes from '../apiRoutes'
import localStorageService from './localStorageService'

class FileServices {
    static async getIncidentImage(name) {
        try {
            if (name) {
                const accessToken = await localStorageService.getItem('access_token')
                const response = await fetch(`${apiroutes.INCIDENTS}/preview/${name}`, { headers: { Authorization: `Bearer ${accessToken}` } })
                if (!response.ok) {
                    throw new Error('Failed to fetch image')
                }
                return window.URL.createObjectURL(await response.blob())
            } else {
                return '/assets/siteLogo/logo.png'
            }
        } catch (error) {
            return '/assets/images/no-header-img.jpg'
        }
    }

    static async getIncidentVideo(name) {
        try {
            if (name) {
                const accessToken = await localStorageService.getItem('access_token');
                const response = await fetch(`${apiroutes.INCIDENTS}/preview/${name}`, { headers: { Authorization: `Bearer ${accessToken}` } });
                if (!response.ok) {
                    throw new Error('Failed to fetch video');
                }
                return window.URL.createObjectURL(await response.blob());
            } else {
                return null;
            }
        } catch (error) {
            return null;
        }
    }

    static async getAnalysistImage(name) {
        try {
            if (name) {
                const accessToken = await localStorageService.getItem('access_token')

                const response = await fetch(`${apiroutes.INCIDENT_ANALYSIS}/preview/${name}`, { headers: { Authorization: `Bearer ${accessToken}` } })
                if (!response.ok) {
                    throw new Error('Failed to fetch image')
                }

                return window.URL.createObjectURL(await response.blob())

            } else {
                return '/assets/siteLogo/logo.png'

            }
        } catch (error) {
            return '/assets/images/no-header-img.jpg'
        }

    }

    // Fetch any analysis file and return an object with a blob URL and content type.
    static async getAnalysistFile(name) {
        try {
            if (name) {
                const accessToken = await localStorageService.getItem('access_token')
                const response = await fetch(`${apiroutes.INCIDENT_ANALYSIS}/preview/${name}`, { headers: { Authorization: `Bearer ${accessToken}` } })
                if (!response.ok) {
                    throw new Error('Failed to fetch file')
                }
                const contentType = response.headers.get('content-type') || '';
                // try to get filename from content-disposition header if present
                const disposition = response.headers.get('content-disposition') || '';
                let filename = name;
                try {
                    const fileMatch = disposition.match(/filename\*?=([^;]+)/i);
                    if (fileMatch && fileMatch[1]) {
                        // handle RFC5987 (UTF-8'') or simple filename
                        let raw = fileMatch[1].trim();
                        // remove surrounding quotes
                        if (raw.startsWith("\"") && raw.endsWith("\"")) raw = raw.slice(1, -1);
                        // handle UTF-8''prefix
                        const utf8Match = raw.match(/UTF-8''(.+)/i);
                        if (utf8Match && utf8Match[1]) {
                            filename = decodeURIComponent(utf8Match[1]);
                        } else {
                            filename = raw;
                        }
                    }
                } catch (e) {
                    // ignore parse errors and fallback to provided name
                }

                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                return { url, contentType, filename };
            }
            return { url: '/assets/siteLogo/logo.png', contentType: 'image/png', filename: name || 'file' };
        } catch (error) {
            return { url: '/assets/images/no-header-img.jpg', contentType: 'image/png', filename: name || 'file' };
        }
    }

}

export default FileServices